import React from 'react';

/**
 * TIN-23 CA-05: Página minimal para proveedores con token expirado o
 * estadoEnvio en {Rechazado, Descartado}. NO debe exponer consecutivo,
 * cliente, items, ni ningún metadato de la requisición.
 */
const MensajeCortesiaProveedor = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: '2rem',
        backgroundColor: '#f8f9fa',
      }}
    >
      <div style={{ maxWidth: 480 }}>
        <h2 style={{ marginBottom: '1.25rem', color: '#212529' }}>
          Gracias por tu interés
        </h2>
        <p style={{ fontSize: '1.1rem', color: '#495057', margin: 0 }}>
          Decidimos no continuar tu proceso.
        </p>
      </div>
    </div>
  );
};

export default MensajeCortesiaProveedor;
